// extracted by mini-css-extract-plugin
export default {"background":"ChatIconStyle_background__edJMY"};